// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"40":"ea85a606752fc4577bd1","668":"df7ed4fe5a5ff648eb24"}[chunkId] + ".css";
};